import { useFormContext } from "react-hook-form";

import { Airline } from "../../../../../../common/types/Airline";
import { ContentReferenceType } from "../../../../../../common/types/ContentReferenceType";
import { ContentAssociationFormState } from "../../../types/ContentAssociationFormState";

export const useSetLookupContent = () => {
    const { reset, getValues } = useFormContext<ContentAssociationFormState>();

    const setMovieContent = (movieId: string, versionIds: string[]) => {
        reset({
            ...getValues(),
            seasonId: "",
            episodeId: "",
            airlineId: "",
            contentType: ContentReferenceType.Movie,
            contentId: movieId,
            versionIds
        });
    };

    const setTvContent = (args: { tvSeriesId: string; seasonId: string; episodeId: string; versionIds: string[] }) => {
        const { tvSeriesId, seasonId, episodeId, versionIds } = args;

        reset({
            ...getValues(),
            airlineId: "",
            contentType: ContentReferenceType.TvSeries,
            contentId: tvSeriesId,
            seasonId: seasonId,
            episodeId: episodeId,
            versionIds
        });
    };

    const setAncillaryContent = (ancillaryId: string, airline: Airline) => {
        reset({
            ...getValues(),
            seasonId: "",
            episodeId: "",
            contentType: ContentReferenceType.Ancillary,
            contentId: ancillaryId,
            airlineId: airline.id,
            versionIds: []
        });
    };

    return { setMovieContent, setTvContent, setAncillaryContent };
};
